export interface UserAccountUpdateSftpSettingsRequestModel {
  host: string;
  port: number;
  username: string;
  password: string;
}
